/**
 * XMLUI Pages Component
 * 
 * This component provides the main content area where page components
 * are rendered. It serves as a container for all feature pages.
 * 
 * Features:
 * - Semantic main content area
 * - Accessibility compliance (WCAG 2.2 AA)
 * - Responsive layout
 * - Skip-to-content target
 * - Page transition support
 * 
 * @see .specify/memory/constitution.md
 * @see /Reference/Reference design-review/design-principles.md
 */

import React, { ReactNode } from 'react';
import { MAIN_CONTENT_CONTAINER, SHELL_CONTENT } from './shellClasses';

interface PagesProps {
  children: ReactNode;
}

/**
 * Pages Component
 * 
 * Provides the main content area for rendering page components.
 * This is where all feature pages (Dashboard, Transactions, etc.) are displayed.
 */
export function Pages({ children }: PagesProps): React.ReactElement {
  return (
    <main 
      id="main-content"
      className="flex-1 min-w-0 max-w-full overflow-x-hidden bg-gray-50 dark:bg-gray-900"
      role="main"
      aria-label="Main content"
    >
      <div className={`${MAIN_CONTENT_CONTAINER} ${SHELL_CONTENT} py-6`}>{children}</div>
    </main>
  );
}
